import React from 'react';

const GDPR = () => {
  return (
    <div className="gdpr-page overflow-x-clip">
      <section className="section bg-white">
        <div className="container mx-auto px-4 sm:px-5 max-w-4xl min-w-0">
          <h1 className="text-2xl min-[400px]:text-3xl sm:text-4xl lg:text-5xl font-heading font-bold mb-8 text-brand-dark-blue break-words leading-tight">
            Ochrana osobných údajov (GDPR)
          </h1>

          <p className="text-lg text-gray-700 mb-6 leading-relaxed">
            Vaše súkromie je pre nás dôležité. Na tejto stránke nájdete informácie o tom,
            ako spracúvame osobné údaje v súlade s nariadením GDPR.
          </p>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            <div>
              <h2 className="text-2xl font-semibold text-brand-dark-blue mb-2">Prevádzkovateľ</h2>
              <p>
                Prevádzkovateľom osobných údajov je Peťo Sloboda (ďalej len „prevádzkovateľ“).
                Kontaktné údaje poskytujeme na vyžiadanie.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-brand-dark-blue mb-2">Aké údaje spracúvame</h2>
              <p>
                Najmä údaje, ktoré nám sami poskytnete prostredníctvom formulárov
                (meno, e‑mail, prípadne ďalšie údaje uvedené v správe).
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-brand-dark-blue mb-2">Účel spracúvania</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>poskytnutie obsahu alebo služieb, o ktoré ste požiadali,</li>
                <li>komunikácia v súvislosti s konzultáciou alebo knihou,</li>
                <li>marketingová komunikácia, ak ste udelili súhlas.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-brand-dark-blue mb-2">Právny základ</h2>
              <p>
                Spracúvanie vykonávame na základe súhlasu, plnenia zmluvy,
                alebo oprávneného záujmu (napr. zabezpečenie prevádzky webu).
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-brand-dark-blue mb-2">Príjemcovia a spracovatelia</h2>
              <p>
                Údaje môžu byť spracúvané zmluvnými partnermi, ktorí zabezpečujú
                technickú prevádzku (napr. e‑mailing, hosting). Údaje neposkytujeme
                tretím stranám na iné účely bez vášho súhlasu.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-brand-dark-blue mb-2">Doba uchovávania</h2>
              <p>
                Osobné údaje uchovávame len po dobu nevyhnutnú na splnenie účelu,
                prípadne do odvolania vášho súhlasu.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-brand-dark-blue mb-2">Vaše práva</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>právo na prístup k údajom,</li>
                <li>právo na opravu alebo vymazanie,</li>
                <li>právo na obmedzenie spracúvania,</li>
                <li>právo namietať,</li>
                <li>právo na prenosnosť údajov,</li>
                <li>právo odvolať súhlas kedykoľvek.</li>
              </ul>
              <p className="mt-2">
                Svoje práva môžete uplatniť prostredníctvom kontaktu s prevádzkovateľom.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-brand-dark-blue mb-2">Záverečné informácie</h2>
              <p>
                Tieto informácie môžu byť priebežne aktualizované. Odporúčame preto
                občasné prečítanie tejto stránky.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GDPR;
